module.exports = __webpack_public_path__ + "static/media/Y_Chuang.6570c064.jpg";